function addQuotation({ userId, metadataId, quotation }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/quotations`;
  return apiClient.post(route, { userId, metadataId, quotation });
}

function updateQuotation({ userId, metadataId, quotationId, quotation }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/quotations/${quotationId}`;
  return apiClient.patch(route, { userId, quotation });
}

function removeQuotation({ userId, quotationId }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/quotations/${quotationId}`;
  return apiClient.delete(route, { userId });
}

export default {
  addQuotation,
  updateQuotation,
  removeQuotation
};



// WEBPACK FOOTER //
// ./app/api/QuotationsApi.js